import { doc, getDoc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { omit } from "lodash";
import { Studio, StudioUpdate } from "../types";
import { saveStudioImages } from "./saveStudioImages";

export const updateStudio = async (
  studioId: string,
  studio: StudioUpdate,
): Promise<Studio> => {
  const studioDocRef = doc(db, "studios", studioId);

  try {
    // Update the document with omitted image fields
    await updateDoc(studioDocRef, {
      ...omit(studio, "logo"),
      updatedAt: serverTimestamp(),
    });

    if (studio.logo instanceof File) {
      await saveStudioImages({
        studioId,
        keyImage: "logo",
        imagesFile: studio.logo,
      });
    }

    // Retrieve the updated studio document
    const updatedStudioSnapshot = await getDoc(studioDocRef);
    return updatedStudioSnapshot.data() as Studio;
  } catch (error) {
    console.error("Failed to update the studio:", error);
    throw error; // Rethrow or handle as needed
  }
};
